import Wizard from 'scoreboard/components/wizard'
import _ from 'lodash'
import UploadForm from 'scoreboard/components/files/upload-form'
import UploadRevisionStep2 from './upload-revision-step2'

const RevisionWizard = Wizard.extend({

	/**
	 * Wizard used to upload a revision for Spider Impact files
	 * when file is used by any value imports
	 *
	 * @constructs
	 *
	 * @param {Object options}
	 *
	 * @param {Document} options.model the document the revision is for
	 */
	initialize(options) {
		let views = [UploadForm, UploadRevisionStep2]
		let opts = _.extend({}, {
			views,
			doneKey: 'documents.revision.imports.run'
		}, options)
		Wizard.prototype.initialize.call(this, opts)
	},

	finish: function (document) {
		this.trigger('done', document)
	}
})

export default RevisionWizard
RevisionWizard.__filename__ = 'documents/revision-wizard.js'
